module.exports = __webpack_public_path__ + "img/mail.e498e951.svg";